import { ICampaignOreOffer, ISoftOfferPackage } from "../types";
import SoftOfferPackageFactory from "../../../factories/campaigns/SoftOfferPackageFactory";
import { IProduct, ITpackage } from "../../product/types";
import ProductFactory from "../../../factories/product/ProductFactory";

export default class OreOffer implements ICampaignOreOffer {

  id: number;
  offerId: number;
  optionName: string;
  products: IProduct[];
  saveDesk: boolean;
  p2p: number;
  contractDuration: any;
  upsell: number;
  featuredPackages: ISoftOfferPackage[];
  unFeaturedPackages: ISoftOfferPackage[];
  greenVoucherDiscount: number;
  ebillDiscount: number;

  constructor(
    id: number,
    offerId: number,
    optionName: string,
    products: IProduct[],
    saveDesk: string,
    p2p: number,
    contractDuration: any,
    upsell: number,
    featuredPackages: ISoftOfferPackage[],
    unFeaturedPackages: ISoftOfferPackage[],
    greenVoucherDiscount: number,
    ebillDiscount: number,
  ) {
    this.id = id;
    this.offerId = offerId;
    this.optionName = optionName;
    this.products = [];
    this.saveDesk = !!saveDesk;
    this.p2p = p2p;
    this.contractDuration = contractDuration;
    this.upsell = upsell;
    this.featuredPackages = [];
    this.unFeaturedPackages = [];
    this.greenVoucherDiscount = greenVoucherDiscount;
    this.ebillDiscount = ebillDiscount;
    if (featuredPackages) {
      featuredPackages.forEach((softOfferPackage: ISoftOfferPackage) => {
        this.featuredPackages.push(SoftOfferPackageFactory.create(softOfferPackage));
      });
    }
    if (unFeaturedPackages) {
      unFeaturedPackages.forEach((softOfferPackage: ISoftOfferPackage) => {
        this.unFeaturedPackages.push(SoftOfferPackageFactory.create(softOfferPackage));
      });
    }
    if (products) {
      products.forEach((product: any) => {
        const featuredPackage = product?.tariffPackages?.find((tariffPackage:ITpackage) =>
          tariffPackage.name === featuredPackages[0].name
        );

        if (featuredPackage) {
          product.assignedTariffPackage = featuredPackage;
        }

        this.products.push(ProductFactory.createFromResponse(product, { greenVoucherDiscount, ebillDiscount }));
      });
    }
  }

}
